// IE9 and onwards support
import "react-app-polyfill/ie9";

import "./javascript/utils/functions/StartFunctions";

window.iframe = true;
window.homeContainer = "HomeContainer";
window.whiteLabel = "mynober";
